import React from "react";

// Styles
import "./styles.scss";
const PageIntroHeader = () => {
  return (
    <div className="page-intro-header">
      <h1 className="header-title">IT Services You Can Count On</h1>
      <h2 className="header-sub-title">
        TRUSTED WEB & MOBILE APP DEVELOPMENT SERVICES
      </h2>
      <p className="header-desc">
        Squareboat is a leading IT services provider which has established a
        name in the industry by delivering great bespoke web and mobile
        applications. Our premium clientele can vouch for our quality of work
        and they trust us for all their critical projects.
      </p>
    </div>
  );
};

export default PageIntroHeader;
